import { render, staticRenderFns } from "./OrderCollection.vue?vue&type=template&id=281145a0&scoped=true&"
import script from "./OrderCollection.vue?vue&type=script&lang=js&"
export * from "./OrderCollection.vue?vue&type=script&lang=js&"
import style0 from "./OrderCollection.vue?vue&type=style&index=0&id=281145a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281145a0",
  null
  
)

export default component.exports